import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrepState25 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.96546 8.00037C4.96546 9.06685 4.10091 9.9314 3.03443 9.9314C1.96795 9.9314 1.10339 9.06685 1.10339 8.00037C1.10339 6.93389 1.96795 6.06934 3.03443 6.06934C4.10091 6.06934 4.96546 6.93389 4.96546 8.00037ZM1.8565 8.00037C1.8565 8.65092 2.38387 9.1783 3.03443 9.1783C3.68498 9.1783 4.21236 8.65092 4.21236 8.00037C4.21236 7.34982 3.68498 6.82244 3.03443 6.82244C2.38387 6.82244 1.8565 7.34982 1.8565 8.00037Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.93104 8.00037C9.93104 9.06685 9.06648 9.9314 8 9.9314C6.93352 9.9314 6.06897 9.06685 6.06897 8.00037C6.06897 6.93389 6.93352 6.06934 8 6.06934C9.06648 6.06934 9.93104 6.93389 9.93104 8.00037ZM6.82207 8.00037C6.82207 8.65092 7.34945 9.1783 8 9.1783C8.65056 9.1783 9.17794 8.65092 9.17794 8.00037C9.17794 7.34982 8.65056 6.82244 8 6.82244C7.34945 6.82244 6.82207 7.34982 6.82207 8.00037Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8965 8.00037C14.8965 9.06685 14.0319 9.9314 12.9655 9.9314C11.899 9.9314 11.0344 9.06685 11.0344 8.00037C11.0344 6.93389 11.899 6.06934 12.9655 6.06934C14.0319 6.06934 14.8965 6.93389 14.8965 8.00037ZM11.7875 8.00037C11.7875 8.65092 12.3149 9.1783 12.9655 9.1783C13.616 9.1783 14.1434 8.65092 14.1434 8.00037C14.1434 7.34982 13.616 6.82244 12.9655 6.82244C12.3149 6.82244 11.7875 7.34982 11.7875 8.00037Z",
			fill: "currentColor"
		})
	]
});
export default SvgPrepState25;
